import type { RouteLocationRaw } from '#vue-router'

export function useNavbarParser() {
  const { t } = useI18n()

  // 菜单标题映射到 i18n 键
  const titleMap: Record<string, string> = {
    硬件产品: 'nav.products',
    '1000bit专用量子计算机': 'nav.product1000bit',
    生态解决方案: 'nav.solutions',
    生物制药: 'nav.solutionBio',
    人工智能: 'nav.solutionAI',
    数字城市: 'nav.solutionCity',
    开物开发者社区: 'nav.developer',
    量子云: 'nav.cloud',
    关于玻色: 'nav.about',
    加入我们: 'nav.join',
    校招职位: 'nav.aboutSchool',
    社招职位: 'nav.aboutSociety',
    企业新闻: 'nav.news',
  }

  return {
    parseMenuTitle: function parseMenuTitle(
      title?: string | ((nuxt: any) => string),
    ) {
      const rawTitle =
        typeof title === 'function' ? title(useNuxtApp()) : title || ''

      // 如果标题在映射表中，使用 i18n 翻译
      if (titleMap[rawTitle]) {
        return t(titleMap[rawTitle])
      }

      return rawTitle
    },
    parseMenuRoute: function parseMenuRoute(
      to?: RouteLocationRaw | ((nuxt: any) => RouteLocationRaw),
    ) {
      return typeof to === 'function' ? to(useNuxtApp()) : to
    },
  }
}
